export function SET_POLICY({commit}, [value]) {
    commit('SAVE_POLICY', [value])
}

export function SET_POLICY_PREFERENCES({commit}, [value]) {
    commit('SAVE_POLICY_PREFERENCES', [value])
}

export function SET_COOKIES({commit}, [value]) {
    commit('SAVE_COOKIES', [value])
}

export function SET_OPTIONAL_COOKIES({commit}, [value]) {
    commit('SAVE_OPTIONAL_COOKIES', [value])
}